import { FC, useEffect } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { Manufacturer } from "../../http/manufacturers/types";
import Form from "../ui/Form";
import FormField from "../ui/FormField";
import FormFieldsContainer from "../ui/FormFieldsContainer";
import Input from "../ui/Input";

export interface ManufacturerFormBody {
  name: string;
}

type ManufacturerFormProps = {
  manufacturer?: Manufacturer | null;
  onSubmit: (form: ManufacturerFormBody) => Promise<void>;
  isDisabled?: boolean;
  isLoading?: boolean;
};

const ManufacturerForm: FC<ManufacturerFormProps> = ({
  manufacturer,
  onSubmit,
  isDisabled,
  isLoading,
}: ManufacturerFormProps) => {
  const i18n = useI18n();

  const defaultValues = {
    name: manufacturer?.name,
  };

  return (
    <Form<ManufacturerFormBody>
      defaultValues={defaultValues}
      submitText={i18n.t.common.save}
      disabled={isDisabled}
      onSubmit={() => onSubmit}
      itemCreationInfo={manufacturer}
    >
      {({ register, reset, formState: { errors } }) => {
        useEffect(() => {
          reset(defaultValues);
        }, [manufacturer]);

        return (
          <FormFieldsContainer>
            <FormField label={i18n.t.common.name} error={errors.name}>
              {({ labelId, isInvalid, isOptional }) => (
                <Input
                  id={labelId}
                  isInvalid={isInvalid}
                  disabled={isDisabled || isLoading}
                  {...register("name", {
                    required: !isOptional,
                    minLength: 1,
                  })}
                />
              )}
            </FormField>
          </FormFieldsContainer>
        );
      }}
    </Form>
  );
};

export default ManufacturerForm;
